
import { useContext } from 'react';
import { ThemeContext } from '../../../contexts/ThemeContext'

type CustomIconProps = {
    light: any,
    dark: any,
    size: number
}

const CustomIcon = (props: CustomIconProps) => {
    const {light, dark, size} = props
    const { theme } = useContext(ThemeContext);

    const icon = theme === 'dark'
        ? dark
        : light;

    return (
        <img
            className="ant-menu-item-icon"
            src={icon}
            width={size}
            height={size} />
    );
};

export default CustomIcon;
